<template>
  <footer class="app-footer">
    &copy; 2019 Copyright. v.2.0
    <!-- <span class="float-right">Powered by <a href="http://coreui.io">CoreUI</a></span> -->
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
};
</script>



// WEBPACK FOOTER //
// Footer.vue?e0df5972